module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/categories/blood-fc55c95196345e4b8736f94c9c74e71c.png";